const Config = {
  social: {
    linkedin: process.env.REACT_APP_SOCIAL_MEDIA_LINKEDIN_URL,
    whatsapp: process.env.REACT_APP_SOCIAL_MEDIA_WHATSAPP_URL,
    github: process.env.REACT_APP_GITHUB_URL,
  },
};

export default Config;
